import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { Observable } from 'rxjs';
import { MyErrorStateMatcher } from 'src/app/components/ott-voucher/voucher-input/voucher-input.component';
import { InitiateTransactionResponse } from 'src/app/interfaces/ott-voucher/InitiateTransactionResponse';
import { OttVoucherService } from 'src/app/services/ott-voucher/ott-voucher.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-voucher-input-version-two',
  templateUrl: './voucher-input.component.html',
  styleUrls: ['./voucher-input.component.scss']
})
export class VoucherInputComponent implements OnInit {
  public loading = false;
  public paymentOptionsLoadedJustify = 'space-between !important';
  public color: ThemePalette = 'primary';
  public diameter = 50;
  public voucherNumber = new FormControl('', [Validators.required]);
  public mobileNumber = new FormControl('', [Validators.required, Validators.pattern('^\\+?\\d{0,2}\\s?\\(?\\d{3}\\)?[-\\s]?\\d{3}[-\\s]?\\d{4}$')]);
  public walletClass = '';
  paymentMethod = 'secure-eft';
  public validationErrors = false;
  public validationErrorMessage = 'Error: ';
  matcher = new MyErrorStateMatcher();
  applicationDetailsForm: FormGroup;
  session: Session;
  mobile;
  public headerColor = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ottVoucherService: OttVoucherService,
    private breakpointObserver: BreakpointObserver,
    private _snackBar: MatSnackBar,
    private sessionService: SessionService
  ) {
    this.loading = false;

    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.applicationDetailsForm = new FormGroup({
      voucherNumber: this.voucherNumber,
      mobileNumber: this.mobileNumber
    });
   }

  ngOnInit(): void {
    this.session = (JSON.parse(sessionStorage.getItem('sessionData')) as Session);
  }

  getColorScheme(): string {
    if (this.session && this.session.sessionDisplayInformation && this.session.sessionDisplayInformation.colorScheme) {
      return this.session.sessionDisplayInformation.colorScheme.replace(';', '');
    }
    return 'inherit';
  }

  getTextColor(): string {
    if (this.session && this.session.sessionDisplayInformation && this.session.sessionDisplayInformation.colorScheme) {
      let bgColor:string = this.session.sessionDisplayInformation.colorScheme.replace(';', '');
      let color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      let r = parseInt(color.substring(0, 2), 16); // Red
      let g = parseInt(color.substring(2, 4), 16); // Green
      let b = parseInt(color.substring(4, 6), 16); // Blue

      // Calculate the perceptive luminance
      let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // Return black for bright colors, white for dark colors
      return luminance > 0.5 ? '#000000' : '#FFFFFF';
    }
    return 'inherit';
  }

  initiateVoucherTransaction() {
    this.validationErrors = false;
    this.validationErrorMessage = 'Error: ';
    this.loading = true;
    this.ottVoucherService.initiateTransaction(this.voucherNumber.value, this.mobileNumber.value)
      .subscribe((data: InitiateTransactionResponse) => {
      sessionStorage.setItem('ott-voucher-transactionId', data.transactionId);
      sessionStorage.setItem('voucherNumber', this.voucherNumber.value);
      sessionStorage.setItem('mobileNumber', this.mobileNumber.value);
      sessionStorage.setItem('voucherValid', String(data.success));
      if (data.success) {
        this.router.navigate(['processing'], {relativeTo: this.route.parent});
      } else {
        this.loading = false;
        this.validationErrors = true;
        this.voucherNumber.setAsyncValidators(this.voucherError);
        // this.applicationDetailsForm.controls['voucherNumber'].setErrors({validationFailed: true})
        this.validationErrorMessage = data.message;
        this._snackBar.open(data.message, 'Error', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        // this.router.navigate(['processing'], {relativeTo: this.route.parent});
      }
    });
  }

  voucherError(control: AbstractControl): Observable<{[key: string]: any}> {
    return Observable.create(observer => {
      if (sessionStorage.getItem('voucherValid') !== 'true') {
        observer.next({validationFailed: true});
      }
      else {
        observer.next(null);
      }
      observer.complete();
    });
  }

  cancelTransaction() {
    this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status/userCancelled`]);
  }

  goBack() {
    sessionStorage.setItem('goBack', 'true');
    return this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}`]);
  }

  getErrorMessage() {

    if (this.voucherNumber.hasError('required')) {
      return 'You must enter a value';
    }

    if (this.mobileNumber.hasError('required')) {
      return 'You must enter a value';
    }

    if (this.validationErrors) {
      return this.validationErrorMessage;
    }
  }

}
